export const initDivTime = (timeCounter, timeIcons) => {
	const DayTimes = {
		MORNING: `data-morning`,
		DAY: `data-day`,
		EVENING: `data-evening`,
		NIGHT: `data-night`,
	};

	const setIcon = (currentDayTime) => {
		Object.values(DayTimes).forEach((dayTime) => dayTime === currentDayTime ? timeIcons.setAttribute(currentDayTime, ``) : timeIcons.removeAttribute(dayTime, ``));
	};

	const startClock = () => {
		const date = new Date();
		const hours = (date.getHours() < 10) ? '0' + date.getHours() : date.getHours();
		const minutes = (date.getMinutes() < 10) ? '0' + date.getMinutes() : date.getMinutes();

		if (hours >= 9 && hours < 11)
		{
			setIcon(DayTimes.MORNING);
		}

		if (hours >= 11 && hours < 17)
		{
			setIcon(DayTimes.DAY);
		}

		if (hours >= 17 && hours < 21)
		{
			setIcon(DayTimes.EVENING);
		}

		if (hours >= 21 && hours < 9)
		{
			setIcon(DayTimes.NIGHT);
		}

		timeCounter.textContent = `${hours}:${minutes}`;
	};

	setInterval(startClock, 1000);
};
